const form = document.querySelector('.form');
const pages = form.querySelectorAll('.form-page');
const progressLines = form.querySelectorAll('.progress-line');
const nextButton = form.querySelector('.next-button');
const nextButton2 = form.querySelector('.next-button2');
const submitButton = form.querySelector('.submit-button');
const deliverInput = document.getElementById('deliver-input');
const cityInput = document.getElementById('city-input');
const dateInput = document.getElementById('date-input');
const descInput = document.getElementById('desc-input');
const typeInput = document.getElementById('type-input');
const weightInput = document.getElementById('weight-input');
const nameInput = document.getElementById('name-input');
const phoneInput = document.getElementById('phone-input');
const emailInput = document.getElementById('email-input');
const nextButtonTxt = document.querySelectorAll('.next-button span');
const nextButton2Txt = document.querySelectorAll('.next-button2 span');
const submitButtonTxt = document.querySelectorAll('.submit-button span');
const phone3 = document.querySelector('#phone3');

let currentPage = 0;

const iti = window.intlTelInput(phoneInput, {
  initialCountry: 'ua',
  separateDialCode: true,
  nationalMode: false,
  utilsScript:
    'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js',
});

function updatePhoneNumber() {
  const phoneNumberWithDialCode = iti.getNumber();
  return phoneNumberWithDialCode;
}

function isValidNumber() {
  const isValidNumber = iti.isValidNumber();
  return isValidNumber;
}

function showPage(pageIndex) {
  pages.forEach((page, index) => {
    if (index === pageIndex) {
      page.classList.add('active');
    } else {
      page.classList.remove('active');
    }
  });

  updateProgress(pageIndex);
}

function updateProgress(pageIndex) {
  progressLines.forEach((line, index) => {
    if (index < pageIndex) {
      line.classList.add('done');
      line.textContent = '✓';
    } else if (index === pageIndex) {
      line.classList.add('active');
    } else {
      line.classList.remove('done');
      line.textContent = index + 1;
    }
  });
}

deliverInput.addEventListener('input', updateNextButtonState);
cityInput.addEventListener('input', updateNextButtonState);

function updateNextButtonState() {
  if (deliverInput.value.trim()) {
    deliverInput.classList.remove('red-border');
    deliverInput.classList.add('green-border');
  } else {
    deliverInput.classList.remove('green-border');
    deliverInput.classList.add('red-border');
  }

  if (cityInput.value.trim()) {
    cityInput.classList.remove('red-border');
    cityInput.classList.add('green-border');
  } else {
    cityInput.classList.remove('green-border');
    cityInput.classList.add('red-border');
  }

  if (deliverInput.value.trim() === '' || cityInput.value.trim() === '') {
    nextButton.disabled = true;
    nextButton.classList.add('disabled-btn');
    nextButtonTxt.forEach((e) => e.classList.add('disabled'));
  } else {
    nextButton.disabled = false;
    nextButton.classList.remove('disabled-btn');
    nextButtonTxt.forEach((e) => e.classList.remove('disabled'));
  }
}

updateNextButtonState();

dateInput.addEventListener('input', updateNextButtonState2);
descInput.addEventListener('input', updateNextButtonState2);
typeInput.addEventListener('input', updateNextButtonState2);
weightInput.addEventListener('input', updateNextButtonState2);

function updateNextButtonState2() {
  const dateValue = dateInput.value.trim();
  const descValue = descInput.value.trim();
  const typeValue = typeInput.value;
  const weightValue = weightInput.value;

  if (dateInput.value.trim()) {
    dateInput.classList.remove('red-border');
    dateInput.classList.add('green-border');
  } else {
    dateInput.classList.remove('green-border');
    dateInput.classList.add('red-border');
  }

  if (descInput.value.trim()) {
    descInput.classList.remove('red-border');
    descInput.classList.add('green-border');
  } else {
    descInput.classList.remove('green-border');
    descInput.classList.add('red-border');
  }

  if (weightInput.value.trim()) {
    weightInput.classList.remove('red-border');
    weightInput.classList.add('green-border');
  } else {
    weightInput.classList.remove('green-border');
    weightInput.classList.add('red-border');
  }

  if (
    dateValue !== '' &&
    descValue !== '' &&
    typeValue !== '' &&
    weightValue !== ''
  ) {
    nextButton2.disabled = false;
    nextButton2.classList.remove('disabled-btn');
    nextButton2Txt.forEach((e) => e.classList.remove('disabled'));
  } else {
    nextButton2.disabled = true;
    nextButton2.classList.add('disabled-btn');
    nextButton2Txt.forEach((e) => e.classList.add('disabled'));
  }
}

updateNextButtonState2();

nameInput.addEventListener('input', validateForm);
phoneInput.addEventListener('input', validateForm);
emailInput.addEventListener('input', validateForm);

function validateForm() {
  const nameValue = nameInput.value.trim();
  phone3.value = updatePhoneNumber();
  phoneInput.value = phoneInput.value.replace(/[^\d]/g, '');
  const emailValue = emailInput.value.trim();

  const nameRegex = /^[A-Za-zА-Яа-яЁё\- ]+$/;
  const phoneRegex =
    /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const isValidName = nameRegex.test(nameValue);
  const isValidPhone = phoneRegex.test(updatePhoneNumber());
  const isValidEmail = emailRegex.test(emailValue);

  if (isValidName && isValidPhone && isValidEmail) {
    submitButton.disabled = false;
    submitButton.classList.remove('disabled-btn');
    submitButtonTxt.forEach((e) => e.classList.remove('disabled'));
  } else {
    submitButton.disabled = true;
    submitButton.classList.add('disabled-btn');
    submitButtonTxt.forEach((e) => e.classList.add('disabled'));
  }
  if (isValidName) {
    nameInput.classList.remove('red-border');
    nameInput.classList.add('green-border');
  } else {
    nameInput.classList.remove('green-border');
    nameInput.classList.add('red-border');
  }
  if (isValidPhone) {
    phoneInput.classList.remove('red-border');
    phoneInput.classList.add('green-border');
  } else {
    phoneInput.classList.remove('green-border');
    phoneInput.classList.add('red-border');
  }
  if (isValidEmail) {
    emailInput.classList.remove('red-border');
    emailInput.classList.add('green-border');
  } else {
    emailInput.classList.remove('green-border');
    emailInput.classList.add('red-border');
  }
}

validateForm();

function goToNextPage(e) {
  e.preventDefault();
  if (currentPage < pages.length - 1) {
    currentPage++;
    showPage(currentPage);
  }
}

function submitForm() {
  currentPage = 0;
  showPage(currentPage);
  updateProgress(-1);

  progressLines.forEach((e, index) => {
    if (index > 0) {
      e.classList.remove('active');
    }
  });

  submitButton.classList.add('disabled-btn');
  submitButtonTxt.forEach((e) => e.classList.add('disabled'));
  nextButton2.disabled = true;
  nextButton2.classList.add('disabled-btn');
  nextButton2Txt.forEach((e) => e.classList.add('disabled'));
  nextButton.disabled = true;
  nextButton.classList.add('disabled-btn');
  nextButtonTxt.forEach((e) => e.classList.add('disabled'));
}

nextButton.addEventListener('click', goToNextPage);
nextButton2.addEventListener('click', goToNextPage);
submitButton.addEventListener('click', submitForm);

showPage(currentPage);

const formOptions = document.querySelectorAll('.form__option');
const dropdownInput = document.getElementById('type-input');
const dropdown = document.querySelector('.form__dropdown');

dropdownInput.addEventListener('click', (e) => {
  handleDropdownClick();
});

function handleDropdownClick() {
  dropdown.classList.toggle('form__dropdown--visible');
}

formOptions.forEach((item) => {
  item.addEventListener('click', function handleItemClick(e) {
    e.stopPropagation();

    dropdownInput.setAttribute('value', item.dataset.value);
    dropdownInput.setAttribute('placeholder', item.dataset.value);
  });
});

document.addEventListener('click', handleCloseDropdown);
document.addEventListener('keydown', handleKeydownClose);

function handleCloseDropdown(e) {
  if (e.target !== dropdownInput) {
    dropdown.classList.remove('form__dropdown--visible');
  }
}

function handleKeydownClose(e) {
  if (e.key === 'Tab' || e.key === 'Escape') {
    dropdown.classList.remove('form__dropdown--visible');
  }
}
